import { render, staticRenderFns } from "./homebottom2.vue?vue&type=template&id=23bd6332&scoped=true"
import script from "./homebottom2.vue?vue&type=script&lang=js"
export * from "./homebottom2.vue?vue&type=script&lang=js"
import style0 from "./homebottom2.vue?vue&type=style&index=0&id=23bd6332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bd6332",
  null
  
)

export default component.exports